import * as yup from "yup";
import { formatarCnpj, formatarCpf } from "../../../../infra/utils/FormataValores";
import { validarCnpj, validarCpf } from "../../../../infra/utils/ValidacaoCpf";

const validaNumeros = yup.number("Só é possível inserir números neste campo");

const schema = yup.object().shape({
    Id: yup.number("Só é possível inserir números neste campo"),
    CodigoResponsavelTecnico: validaNumeros,
    Situacao: validaNumeros,
    Protocolo: yup.string(),
    Inscricao: yup.string()
    .required("Campo obrigatório")
    .test("inscricao-valida", "Inscrição inválida", function(value) {
        if (!value) return true;

        const { TipoInscricao } = this.parent;
        const tipoInscricao = TipoInscricao?.value;

        const limpo = value.replace(/[\s.\-/_]/g, "");
        if (limpo.length === 0) return true;

        if (tipoInscricao === 1) {
            const cpf = formatarCpf(value);
            return validarCpf(cpf);
        } else {
            const cnpj = formatarCnpj(value);
            return validarCnpj(cnpj);
        }
    }),
    Nome: yup.string().required("Campo obrigatório"), // INTERESSADO
    FoneCelular1: yup.string().transform((value) => value.replace(/[\s()+\-_]/g, '')), // INTERESSADO
    FoneCelular2: yup.string().transform((value) => value.replace(/[\s()+\-_]/g, '')), // INTERESSADO
    Email: yup.string().email("É necessário informar um e-mail válido").required("Campo obrigatório"), // INTERESSADO
    Endereco: yup.string().required("Campo obrigatório"), 
    CEP: yup.string().required("Campo obrigatório"), 
    Cidade: yup.string().required("Campo obrigatório"), 
    Rua: yup.string().required("Campo obrigatório"), 
    NumeroEnd: yup.number("Só é possível informar números neste campo").typeError("Valor informado é inválido. Este campo é obrigatório").min(0, "O valor mínimo é zero").required("Este campo é obrigatório"), 
    PotenciaInstalada: yup.number("Só é possível informar números neste campo").typeError("Valor informado é inválido. Este campo é obrigatório").moreThan(0, "O valor deve ser maior que zero").required("Este campo é obrigatório"), 
    Complemento: yup.string(), 
    UF: yup.object().required("Este campo é obrigatório").shape({
        value: yup.string(),
        label: yup.string()
    }), 
    Longitude: validaNumeros, 
    Latitude: validaNumeros, 
    DisjustorUc: yup.number("Só é possível informar números neste campo").typeError("Valor informado é inválido. Este campo é obrigatório").min(0, "O valor mínimo é zero").integer("O valor não deve possuir casas decimais").required("Este campo é obrigatório"), // GERAÃ‡ÃƒO 5
    AreaArranjos: yup.number("Só é possível informar números neste campo").typeError("Valor informado é inválido. Este campo é obrigatório").min(0, "O valor mínimo é zero").required("Este campo é obrigatório"), // GERAÃ‡ÃƒO 5
    BitolaRamal: yup.number("Só é possível informar números neste campo").typeError("Valor informado é inválido. Este campo é obrigatório").min(0, "O valor mínimo é zero").required("Este campo é obrigatório"), // GERAÃ‡ÃƒO 4
    TipoLigacaoTransformador: yup.string().max(60, "Máximo de 60 caracteres.").when(["TransformadorParticular", "TipoInstalacao", "Id"], (transfParticular, tipoInstal, codigoSolic, schema) => {
                                                    if(codigoSolic !== 0) {
                                                        return ((transfParticular && transfParticular?.value !== 1) || (tipoInstal && tipoInstal?.value !== 1)) ? schema.required("Valor informado é inválido. Este campo é obrigatório") : schema
                                                    } else {
                                                        return schema;
                                                    }
                                                }), // GERAÃ‡ÃƒO 6
    PercImpedanciaTransf: yup.number("Só é possível informar números neste campo").typeError("Valor informado é inválido. Este campo é obrigatório").min(0, "O valor mínimo é zero").required("Este campo é obrigatório"), // GERAÃ‡ÃƒO 7
    habilitaCodigoUC: yup.boolean(),
    CodigoUC: yup.mixed().nullable()
    .when('NovaUC', {
        is: false,
        then: yup.number()
        .transform((value, originalValue) => {
            if (originalValue === '') {
            return undefined;
            }
            return isNaN(value) ? undefined : value;
        })
        .required('Este campo é obrigatório')
        .lessThan(1000000000000, "O valor informado é muito extenso"),
        otherwise: yup.mixed().notRequired().nullable(),
    }),
    CodigoTipoGeracao: yup.object().shape({
        value: yup.number(),
        label: yup.string() // INTERESSADO
    }).nullable(),
    TipoParticipacao: yup.object().shape({
        value: yup.number().required(),
        label: yup.string() // INTERESSADO
    }),
    NovaUC: yup.boolean().default(false),
    Armazenamento: yup.string().max(60, "Máximo de 60 caracteres"),
});


const defaultValues = {
    Id: 0,
    TipoInscricao: { value: 1, label: "CPF" },
    Inscricao: " ",
    Nome: " ",
    FoneCelular1: " ",
    FoneCelular2: " ",
    Email: " ",
    Endereco: " ",
    CEP: " ",
    Cidade: " ",
    Rua: " ",
    NumeroEnd: 0,
    Complemento: " ",
    UF: { value: " ", label: " " },
    PotenciaInstalada: 0,
    FatorPotencia: 0,
    Longitude: 0,
    Latitude: 0,
    DisjustorUc: 0,
    BitolaRamal: 0,
    TipoLigacaoTransformador: " ",
    PercImpedanciaTransf: 0,
    AreaArranjos: 0,
    ModalidadeGD: { value: 1, label: "" },
    TipoConexao: { value: 1, label: "" },
    TipoRamal: { value: 1, label: "" },
    ClassificacaoGeracao: { value: 1, label: "" },
    TipoInstalacao: { value: 1, label: "" },
    TransformadorParticular: { value: 1, label: "" },
    CodigoUC: " ",
    CodigoResponsavelTec: 0,
    NovaUC: false,
    CodigoTipoGeracao: null,
    TipoParticipacao: { value: 1, label: "Porcentagem" },
    Armazenamento: " ",
    habilitaCodigoUC: false
};

const camposPorAba = {
    0: ["TipoInscricao", "Inscricao", "Nome", "FoneCelular1", "FoneCelular2", "Email", "CodigoUC", "NovaUC"],
    1: ["Endereco", "CEP", "Cidade", "Rua", "NumeroEnd", "Complemento", "UF", "Longitude", "Latitude"],
    2: ["ModalidadeGD", "TipoConexao", "DisjustorUc", "BitolaRamal", "ClassificacaoGeracao",
        "TipoInstalacao", "TransformadorParticular", "TipoLigacaoTransformador",
        "PercImpedanciaTransf", "AreaArranjos", "CodigoTipoGeracao", "Armazenamento", "TipoParticipacao"],
    3: ["PotenciaInstalada"],
    4: [], // Participantes / Documentos (sem campos no schema)
    5: [], // Documentos
    6: [], // Resultado
  };
  
export { defaultValues, schema, camposPorAba };